import React from 'react';
import { styled } from '@linaria/react';
const _exp = /*#__PURE__*/() => ({
  width
}) => width;
const LineWrapper = /*#__PURE__*/styled('div')({
  name: "LineWrapper",
  class: "l190ni0t",
  propsAsIs: false,
  vars: {
    "l190ni0t-0": [_exp(), "px"]
  }
});
interface Props {
  width: number;
}
export const Line = ({
  width
}: Props) => <LineWrapper width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 8">
      <circle cx="4" cy="4" r="3" fill="#696663" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <circle cx="10.5" cy="4" r="1" fill="#696663" />
      <circle cx="15.5" cy="4" r="1" fill="#696663" />
      <circle cx="20.5" cy="4" r="1" fill="#696663" />
      <circle cx="25.5" cy="4" r="1" fill="#696663" />
      <circle cx="32" cy="4" r="3" fill="#696663" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  </LineWrapper>;

require("./Line.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Line.tsx");